/* Hallows Night — atmósfera.
   Cuenta atrás, luz que sigue al cursor, cinta que se desplaza y truco o trato.
   Todo es decorativo: si algo falla, la tienda sigue funcionando igual.
   Nada de esto se ejecuta si el sistema pide menos movimiento. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     1. Cuenta atrás
     La fecha viene del editor en formato AAAA-MM-DD y se lee como medianoche
     LOCAL del visitante: quien mira desde California ve su propia cuenta.
     ------------------------------------------------------------------------ */

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function startCountdown(root) {
    var target = root.getAttribute('data-hn-countdown');
    if (!target) return;

    var parts = target.split('-');
    if (parts.length !== 3) return;

    var end = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 0, 0, 0, 0);
    if (isNaN(end.getTime())) return;

    var slots = {
      d: root.querySelector('[data-hn-d]'),
      h: root.querySelector('[data-hn-h]'),
      m: root.querySelector('[data-hn-m]'),
      s: root.querySelector('[data-hn-s]')
    };
    var clock = root.querySelector('.hn-count__clock');
    var over = root.querySelector('.hn-count__over');

    function paint() {
      var left = end.getTime() - Date.now();

      if (left <= 0) {
        if (clock) clock.hidden = true;
        if (over) over.hidden = false;
        return false;
      }

      var total = Math.floor(left / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (slots.d) slots.d.textContent = String(d);
      if (slots.h) slots.h.textContent = pad(h);
      if (slots.m) slots.m.textContent = pad(m);
      if (slots.s) slots.s.textContent = pad(s);
      return true;
    }

    if (!paint()) return;
    root.setAttribute('data-hn-live', 'true');

    var timer = window.setInterval(function () {
      if (!paint()) window.clearInterval(timer);
    }, 1000);

    // Al volver a la pestaña, repintar de inmediato en vez de esperar al tick.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) paint();
    });
  }

  /* ------------------------------------------------------------------------
     2. Luz que sigue al cursor dentro de su sección
     ------------------------------------------------------------------------ */

  function startCursorLight(host) {
    if (reduce) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var light = document.createElement('div');
    light.className = 'hn-cursorlight';
    light.setAttribute('aria-hidden', 'true');
    host.appendChild(light);

    var x = 0;
    var y = 0;
    var pending = false;

    function draw() {
      pending = false;
      light.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }

    host.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var box = host.getBoundingClientRect();
      x = e.clientX - box.left;
      y = e.clientY - box.top;
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(draw);
      }
    });

    host.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') light.classList.add('is-on');
    });

    host.addEventListener('pointerleave', function () {
      light.classList.remove('is-on');
    });
  }

  /* ------------------------------------------------------------------------
     3. Cinta: se duplica el grupo hasta cubrir el doble del ancho visible,
     que es lo que la animación da por hecho al desplazar un -50 %.
     ------------------------------------------------------------------------ */

  function startMarquee(root) {
    var track = root.querySelector('.hn-marquee__track');
    var group = track && track.querySelector('.hn-marquee__group');
    if (!track || !group) return;

    var needed = root.offsetWidth * 2;
    var guard = 0;

    while (track.scrollWidth < needed && guard < 12) {
      track.appendChild(group.cloneNode(true));
      guard++;
    }

    // La animación desplaza la mitad exacta de la pista, así que hace falta
    // un número par de grupos para que el bucle no dé un salto.
    if (track.children.length % 2 !== 0) {
      track.appendChild(group.cloneNode(true));
    }

    var speed = Number(root.getAttribute('data-hn-speed')) || 34;
    // Velocidad constante en píxeles por segundo, sea cual sea el ancho.
    var seconds = Math.max(12, (track.scrollWidth / 2 / 40) * (34 / speed));
    track.style.setProperty('--hn-marquee-speed', seconds.toFixed(1) + 's');
  }

  /* ------------------------------------------------------------------------
     4. Truco o trato: puertas que se abren. Un botón por puerta, con
     aria-expanded, y se cierra con Escape.
     ------------------------------------------------------------------------ */

  function startTrick(root) {
    var doors = root.querySelectorAll('.hn-trick__door');

    doors.forEach(function (door) {
      door.addEventListener('click', function () {
        var open = door.getAttribute('aria-expanded') === 'true';
        door.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      doors.forEach(function (door) {
        door.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ------------------------------------------------------------------------
     Arranque. Se vuelve a llamar cuando el editor de temas recarga una
     sección, para que lo que se acaba de pintar también quede vivo.
     ------------------------------------------------------------------------ */

  function boot(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-hn-countdown]:not([data-hn-live])').forEach(startCountdown);
    root.querySelectorAll('[data-hn-cursorlight]:not([data-hn-fx])').forEach(function (el) {
      el.setAttribute('data-hn-fx', '1');
      startCursorLight(el);
    });
    root.querySelectorAll('.hn-marquee:not([data-hn-fx])').forEach(function (el) {
      el.setAttribute('data-hn-fx', '1');
      startMarquee(el);
    });
    root.querySelectorAll('[data-hn-trick]:not([data-hn-fx])').forEach(function (el) {
      el.setAttribute('data-hn-fx', '1');
      startTrick(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
